import { StatusChip, appointmentStatusSemantic } from '@scripsteam/scrips-signal-ds';

/**
 * AppointmentStatusSummary — the status line at the TOP of the Edit-Appointment form (19 Oct, Antonin).
 *
 * ONE line: the label "Status", the actual status as the app's soft status chip (semantic from the DS's
 * single appointment-status map, the same one the calendar and the patient appointment tables read;
 * Fulfilled reads "Completed"), then "Booking reference {ref}" in meta ("N/A" when missing).
 * Edit mode only, for every status (Flutter `appointment_status_widget.dart`, mounted as
 * `isEdit ? AppointmentStatusWidget(...) : Container()`). The old Cancelled / No Show rows are gone:
 * the chip itself says it.
 *
 * FHIR mapping: Appointment.status (booked / fulfilled / cancelled / noshow).
 */

interface AppointmentStatusSummaryProps {
  currentStatus?: { code?: string | null; display?: string | null } | null;
  /** Backend booking reference (Flutter `appointment.referenceId`). */
  referenceId?: string | number | null;
}

export function AppointmentStatusSummary({
  currentStatus,
  referenceId,
}: AppointmentStatusSummaryProps) {
  const code = (currentStatus?.code ?? '').trim();
  const display = currentStatus?.display?.trim();
  const label = /^fulfilled$/i.test(code) ? 'Completed' : display || code || 'Booked';
  const ref =
    referenceId != null && `${referenceId}`.trim() !== '' ? referenceId : 'N/A';

  return (
    <section className="booking-status-line" data-slot="booking-status-line">
      <h3 className="booking-section-label">Status</h3>
      <StatusChip semantic={appointmentStatusSemantic(code || label)} tone="soft">
        {label}
      </StatusChip>
      <span className="booking-status-ref">
        Booking reference {ref}
      </span>
    </section>
  );
}
